import 'reset-css'
import '../node_modules/foundation-sites/dist/css/foundation.min.css'
import 'aos/dist/aos.css'
import './assets/scss/style.scss'

import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import App from './App.vue'

Vue.use(VueRouter)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')